import { Box, Typography } from "@mui/material";

import { getScoreColor, SCORE_SEGMENTS, UNFILLED_COLOR } from "./constants";

interface MetricPillProps {
  label: string;
  score: number;
  justification: string;
  isExpanded: boolean;
  onToggle: () => void;
  icon: React.ReactNode;
}

const MetricPill = ({
  label,
  score,
  justification,
  isExpanded,
  onToggle,
  icon
}: MetricPillProps) => {
  const color = getScoreColor(score);

  return (
    <Box
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onToggle();
      }}
      sx={{
        bgcolor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "6px",
        p: "10px 8px",
        display: "flex",
        flexDirection: "column",
        gap: 0.75,
        transition: "all 0.2s ease",
        cursor: "pointer",
        "&:hover": {
          boxShadow:
            "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
          transform: "translateY(-1px)"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          {icon}
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 500,
              color: "#6b7280",
              whiteSpace: "nowrap"
            }}
          >
            {label}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: "2px", height: "4px" }}>
        {SCORE_SEGMENTS.map((segment) => (
          <Box
            key={segment}
            sx={{
              flex: 1,
              bgcolor: segment <= score ? color : UNFILLED_COLOR,
              borderRadius: "2px"
            }}
          />
        ))}
      </Box>
      {isExpanded && (
        <Typography
          sx={{
            fontSize: "12px",
            color: "#374151",
            lineHeight: 1.5,
            mt: 1,
            pt: 1,
            borderTop: "1px solid #e5e7eb"
          }}
        >
          {justification}
        </Typography>
      )}
    </Box>
  );
};

export default MetricPill;
